import React from 'react'
import PropTypes from 'prop-types'
import ReactTable from 'react-table-v6'
import { toString } from 'lodash'

import ColumnTransformer from './utilities/ColumnTransformer'

const Table = ({ columns, data, tableProps, Filter, ...props }) => (
  <ReactTable
    {...{
      data,
      columns: ColumnTransformer(columns),
      minRows: 0,
      Filter,
      defaultFilterMethod: (filter, row) => regexSearch({ row, filter }),
      ...tableProps,
      ...props,
    }}
  />
)

const FilterComponent = ({ filter, onChange, column }) => (
  <label>
    <input
      type="text"
      style={{ width: '100%' }}
      placeholder={column.Placeholder}
      value={filter ? filter.value : ''}
      onChange={event => onChange(event.target.value)}
    />

    <select>
      <option>Plain</option>
      <option>Regex</option>
    </select>
  </label>
)

function regexSearch({ row, filter }) {
  const value = filter.value
  const rowValue = toString(row[filter.id])
  const regex = new RegExp(value, 'i')

  try {
    return rowValue.match(regex)
  } catch (e) {
    return rowValue.match(value)
  }
}

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape),
  columns: PropTypes.arrayOf(PropTypes.shape),
  tableProps: PropTypes.shape(PropTypes.any),
  Filter: PropTypes.func,
  props: PropTypes.any
}

Table.defaultProps = {
  data: [],
  columns: [],
  tableProps: {},
  Filter: FilterComponent
}

export default Table
